export const SET_UPDATE_NAME_ERRORS = "SET_UPDATE_NAME_ERRORS";
export const RESET_UPDATE_NAME_ERRORS = "RESET_UPDATE_NAME_ERRORS";
export const SET_UPDATE_PASSWORD_ERRORS = "SET_UPDATE_PASSWORD_ERRORS";
export const RESET_UPDATE_PASSWORD_ERRORS = "RESET_UPDATE_PASSWORD_ERRORS";
export const SET_UPDATE_PICTURE_ERRORS = "SET_UPDATE_PICTURE_ERRORS";
export const RESET_UPDATE_PICTURE_ERRORS = "RESET_UPDATE_PICTURE_ERRORS";